import { getProducts } from '../services/api';

export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const FETCH_PRODUCT_LOADING = 'FETCH_PRODUCT_LOADING';

export const setProduct = value => ({
  type: SET_PRODUCT,
  value,
});

export const fetchProduct = product => (dispatch) => {
  dispatch(setProduct(product));
  return Promise.resolve(product);
};

export const fetchProducts = () => dispatch => new Promise(async (resolve, reject) => {
  try {
    const { data } = await getProducts();
    resolve(dispatch({
      type: SET_PRODUCTS,
      value: data,
    }));
  } catch (e) {
    console.log('error', e);
    reject(e);
  }
});
